module.exports = __webpack_public_path__ + "img/congratsbanner.1812579e.svg";